<template>
    <div id="post-list-page" class="container">
        <div class="row">
            <div class="col-lg-8">
                <post-block-group :title="this.getPostType" color="#000" class="ml-0">
                    <div class="col-lg-12 col-md-12">
                        <div class="row" v-for="(item, index) in posts" v-bind:key="item.ID">
                            <post-small-block-horizontal v-bind:data="item"
                                    class="pr-3 pr-lg-0 mb-4 pb-1"></post-small-block-horizontal>
                                    <ad :data="list_inside_1_190" v-if="index === 1 && list_inside_1_190 && list_inside_1_190.id"
                                    class="ml-3 mr-3 mr-lg-0 pb-2"></ad>
                                    <google-ad :data="glist_inside_1_190" v-if="index === 1 && glist_inside_1_190 && glist_inside_1_190.id"
                                    class="ml-3 mr-3 mr-lg-0 pb-2"></google-ad>

                                    <ad :data="list_inside_2_190" v-if="index === 3 && list_inside_2_190 && list_inside_2_190.id"
                                    class="ml-3 mr-3 mr-lg-0 pb-2"></ad>
                                    <google-ad :data="glist_inside_2_190" v-if="index === 3 && glist_inside_2_190 && glist_inside_2_190.id"
                                    class="ml-3 mr-3 mr-lg-0 pb-2"></google-ad>

                                    <ad :data="list_inside_3_190" v-if="index === 6 && list_inside_3_190 && list_inside_3_190.id"
                                        class="ml-3 mr-3 mr-lg-0 pb-2"></ad>
                                    <google-ad :data="glist_inside_3_190" v-if="index === 6 && glist_inside_3_190 && glist_inside_3_190.id"
                                               class="ml-3 mr-3 mr-lg-0 pb-2"></google-ad>

                                    <ad :data="list_inside_4_190" v-if="index === 9 && list_inside_4_190 && list_inside_4_190.id"
                                        class="ml-3 mr-3 mr-lg-0 pb-2"></ad>
                                    <google-ad :data="glist_inside_4_190" v-if="index === 6 && glist_inside_4_190 && glist_inside_4_190.id"
                                               class="ml-3 mr-3 mr-lg-0 pb-2"></google-ad>
                        </div>
                        <div class="row">
                            <pagination :data="pagination" class="pl-3 pb-3"></pagination>
                        </div>
                    </div>
                </post-block-group>
            </div>
            <div class="col-lg-4">
                <div class="row pt-3 ml-lg-0 p-3 p-lg-0" v-if="(list_popular_370 && list_popular_370.id) || (glist_popular_370 && glist_popular_370.id)">
                    <ad :data="list_popular_370" class="p-3 p-lg-0" v-if="(list_popular_370 && list_popular_370.id)"></ad>
                    <google-ad :data="glist_popular_370" class="p-sm-3 p-lg-0" v-if="(glist_popular_370 && glist_popular_370.id)"></google-ad>
                </div>
                <div class="row">
                    <widget v-if="most_popular_post_cover && most_popular_post_cover.title" class="widget row most-recent mt-40 p-0 mr-4 ml-lg-0 ml-md-3 ml-sm-3 ml-xs-3 pl-xs-3" title="Legnépszerűbb">
                        <div class="row pad-right-block">
                            <post-small-block class="" color="#000" :data="this.most_popular_post_cover" v-if="this.most_popular_post_cover"></post-small-block>
                        </div>
                        <div class="row">
                            <div class="list-post-block ">
                                <ul class="list-post unstyled pad-right-block">
                                    <post-list-item-small v-for="item in most_popular_posts" v-bind:data="item" v-bind:key="item.ID">
                                    </post-list-item-small>
                                </ul>
                            </div>
                        </div>
                    </widget>
                </div>
                <div class="row pt-3 ml-3" v-if="(list_popular_600 && list_popular_600.id) || (glist_popular_600 && glist_popular_600.id)">
                    <ad :data="list_popular_600" v-if="(list_popular_600 && list_popular_600.id)"></ad>
                    <google-ad :data="glist_popular_600" v-if="(glist_popular_600 && glist_popular_600.id)"></google-ad>
                </div>
                <div class="row">
                    <widget class="widget row w-fan-page mt-20 p-0 mr-4 ml-lg-0 ml-md-3 ml-sm-3 mr-sm-3 ml-xs-3" title="Kövessen minket">
                        <div class="fb-page pl-0"
                             data-href="https://www.facebook.com/Szekelyfold.ma/"
                             data-width="330"
                             data-hide-cover="true"
                             data-show-facepile="false"></div>
                    </widget>
                </div>
                <div class="row mt-4 mr-0 pr-0 mb-4 campaings">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-0">
                        <div class="row" v-for="campaign in campaigns" v-bind:data="campaign" v-bind:key="campaign.ID">
                            <campaign :data="campaign" class="w-100 p-3"></campaign>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PostBlockGroup from "../post/PostBlockGroup";
    import PostSmallBlockHorizontal from "../post/PostSmallBlockHorizontal";
    import PostListItemSmall from "../post/PostListItemSmall";
    import PostSmallBlock from "../post/PostSmallBlock";
    import Campaign from "../addons/Campaigns";
    import Widget from "../addons/Widget"
    import Pagination from "../common/Pagination";
    import { mapGetters, mapActions } from 'vuex'
    import Ad from '../addons/Ad'
    import GoogleAd from '../addons/GoogleAd'

    export default {
        name: 'PostListPage',
        data() {
            return {
                type: '',
                posts: this.getPosts,
                pagination: this.getPagination,
                most_popular_post_cover: this.getMostPopularPostCover,
                most_popular_posts: this.getMostPopularPosts,
                campaigns: [

                ],
                banners: [],
                list_popular_370: {},
                list_popular_600: {},
                list_inside_1_190: {},
                list_inside_2_190: {},
                list_inside_3_190: {},
                list_inside_4_190: {},

                gbanners: [],
                glist_popular_370: {},
                glist_popular_600: {},
                glist_inside_1_190: {},
                glist_inside_2_190: {},
                glist_inside_3_190: {},
                glist_inside_4_190: {},
            }
        },
        components: {
            Pagination,
            PostListItemSmall,
            PostSmallBlock,
            Campaign,
            Widget,
            PostBlockGroup,
            PostSmallBlockHorizontal,
            Ad,
            GoogleAd,
        },
        computed: {
            ...mapGetters([
                'getMostPopularPostCover',
                'getMostPopularPosts',
                'getPosts',
                'getPostType',
                'getPagination',
            ]),
        },
        methods: {
            getBanners() {
                this.$store.dispatch('getBanners', [
                    'list_popular_370','list_popular_600','list_inside_1_190','list_inside_2_190',
                    'list_inside_3_190', 'list_inside_4_190'
                ]).then((response) => {
                    this.banners = response ? response : [];
                   this.list_popular_370 = this.banners.find(b => b.side === 'list_popular_370');
                   this.list_popular_600 = this.banners.find(b => b.side === 'list_popular_600');
                   this.list_inside_1_190 = this.banners.find(b => b.side === 'list_inside_1_190');
                   this.list_inside_2_190 = this.banners.find(b => b.side === 'list_inside_2_190');
                    this.list_inside_3_190 = this.banners.find(b => b.side === 'list_inside_3_190');
                    this.list_inside_4_190 = this.banners.find(b => b.side === 'list_inside_4_190');
                });

                this.$store.dispatch('getGBanners', [
                    'glist_popular_370','glist_popular_600','glist_inside_1_190','glist_inside_2_190',
                    'glist_inside_3_190', 'glist_inside_4_190'
                ]).then((response) => {
                    this.gbanners = response ? response : [];
                   this.glist_popular_370 = this.gbanners.find(b => b.position === 'glist_popular_370');
                   this.glist_popular_600 = this.gbanners.find(b => b.position === 'glist_popular_600');
                   this.glist_inside_1_190 = this.gbanners.find(b => b.position === 'glist_inside_1_190');
                   this.glist_inside_2_190 = this.gbanners.find(b => b.position === 'glist_inside_2_190');
                    this.glist_inside_3_190 = this.gbanners.find(b => b.position === 'glist_inside_3_190');
                    this.glist_inside_4_190 = this.gbanners.find(b => b.position === 'glist_inside_4_190');
                });
            }
        },
        mounted() {
            this.getBanners();
        },
        watch: {
            getPosts: function(newVal, oldVal) {
                this.posts = newVal;
            },
            getMostPopularPosts: function(newVal, oldVal) {
                this.most_popular_posts = newVal;
            },
            getMostPopularPostCover: function(newVal, oldVal) {
                this.most_popular_post_cover = newVal;
            },
            getPagination: function(newVal) {
                this.pagination = newVal;
            }
        }

    }
</script>

<style lang="scss">
    #post-list-page {
        @media (max-width: 576px) {
            .w-fan-page {
                .block-title {
                    margin-right: 20px;
                }
            }

            .campaings {
                margin-left: 0px;
                margin-right: -15px !important;
            }
        }
    }
</style>
